<template>
  <div>
    <parent-bar></parent-bar>
    <permission-validation :marketId="marketId" rule="enableViewOverall">
      <layout :isSuccess="true">
        <template v-slot:headZone>
          <OverallLayout></OverallLayout>
          <!-- <headline :content="`${'วิเคราะห์' } ${overallName}`"></headline> -->
        </template>
        <template v-slot:containerZone>
          <router-view :isMainLoading="isLoading" :marketId="marketId" :projectId="projectId"></router-view>
        </template>
      </layout>
    </permission-validation>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import FormMeter from "../../components/FormMeter.vue";
import Headline from "../../components/Headline.vue";
import Layout from "../../components/Layout.vue";
import MarketSetting from "../../components/MarketSetting.vue";
import ParentBar from "../../components/ParentBar.vue";
import OverallLayout from "../../components/OverallLayout.vue";
import PermissionValidation from "../../components/PermissionValidation.component.vue";
import { ExportMarketSetting } from "../../exports";
export default {
  components: {
    ParentBar,
    OverallLayout,
    Layout,
    Headline,
    MarketSetting,
    FormMeter,
    PermissionValidation
  },
  computed: {
    ...mapGetters({
      meterSettings: "meter/getMeterSettings",
      billingSettings: "billingSetting/getBillingSettingsWithLabel",
      dailyBillingSettings:
        "dailyBillingSetting/getDailyBillingSettingsWithLabel",
      countSettingTasks: "settingTask/countSettingTasks",
      getSettingTasks: "settingTask/getSettingTasks"
    }),
    ...mapState({
      areas: state => state.area.areas,
      areaAccountingProducts: state =>
        state.areaAccountingProduct.areaAccountingProducts,
      accountingProducts: state => state.accountingProducts.accountingProducts
    }),
    settingType() {
      let settingType = this.$route.fullPath.split("/")[6];
      return settingType;
    },
    overallName() {
      return this.settingType == "income"
        ? this.$t('payment.income')
        : this.settingType == "income_daily"
        ? this.$t('payment.income_daily')
        : "-";
    },
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    }
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      project: null,
      market: null,
      isLoading: false,
      meterDialog: false,
      searchArea: "",
      meterSettingItems: [],
      areasAccountingTable: {},
      areaBillingSettingItems: [],
      billingSettingType: "monthly"
    };
  },

  async created() {
    this.isLoading = true;
    if (this.admin) {
      this.project = this.admin.project;
      this.market = this.admin.market;
    }
    if (this.employee) {
      this.project = this.employee.project;
      this.market = this.employee.market;
    }
    try {
      await this.$store.dispatch("markets/getMarketArea", {
        id: this.marketId
      });
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
    }
  },
  methods: {
    async saveMeter(value) {
      try {
        this.isLoading = true;
        const meter = await this.$store.dispatch("meter/createMeter", {
          name: value.name,
          areaId: value.areaId,
          type: this.settingType
        });
        await this.initAfterSaveMeter();
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
      }
    },
    async initAfterSaveMeter() {
      try {
        await this.$store.dispatch("markets/getMarketArea", {
          id: this.marketId
        });
        // if(this.settingType == 'water' || this.settingType == 'elec')
        await this.onInitMeterSetting();
      } catch (err) {}
    },
    async onInitMeterSetting() {
      this.isLoading = true;
      this.meterSettingItems = [];
      await this.$store.dispatch(
        "accountingProducts/getAccountingProducts",
        this.projectId
      );
      await this.onGetMeterSetting(this.settingType);
      await this.onGetBillingSetting("meter");
      this.isLoading = false;
    },
    async onGetMeterSetting(params) {
      const meterType =
        params == "water" ? "water" : params == "elec" ? "elec" : false;
      if (meterType) {
        await this.$store.dispatch("meter/getMeterByMarket", {
          marketId: this.marketId,
          type: meterType
        });
      }
    },
    async onGetBillingSetting(params) {
      if (params == "meter") {
        await this.$store.dispatch(
          "billingSetting/getBillingSettingsByMeters",
          {
            meterIds: this.$store.getters["meter/getMeterIds"]
          }
        );
        this.meterSettingItems = this.meterSettingItemsFn();
      }
    },
    meterSettingItemsFn() {
      let res = [];
      let bsOjb = {};
      if (this.meterSettings && this.billingSettings) {
        for (const billingSetting of this.billingSettings) {
          if (billingSetting.meter) {
            if (!bsOjb[billingSetting.meter.objectId])
              bsOjb[billingSetting.meter.objectId] = [];
            bsOjb[billingSetting.meter.objectId].push(billingSetting);
          }
        }
        for (let meterSetting of this.meterSettings) {
          if (bsOjb[meterSetting.objectId])
            meterSetting.billingSetting = bsOjb[meterSetting.objectId];

          meterSetting.nameText = meterSetting.isMain
            ? meterSetting.name
              ? meterSetting.name
              : this.$t('main')
            : meterSetting.name
            ? meterSetting.name
            : this.$t('additional');
          meterSetting.serviceText = bsOjb[meterSetting.objectId]
            ? bsOjb[meterSetting.objectId]
                .map(i => i.accountingProduct.name)
                .join(",")
            : "-";
          meterSetting.unitText = bsOjb[meterSetting.objectId]
            ? bsOjb[meterSetting.objectId].map(i => i.typeString).join(",")
            : "-";
          meterSetting.costText = bsOjb[meterSetting.objectId]
            ? bsOjb[meterSetting.objectId]
                .map(i => this.$helper.toCurrency(i.cost))
                .join(",")
            : "-";
          meterSetting.totalText = bsOjb[meterSetting.objectId]
            ? bsOjb[meterSetting.objectId]
                .map(i =>
                  i.discountType == 2
                    ? this.$helper.toCurrency(
                        this.$helper.round(
                          i.cost - (i.cost * (i.discount || 0)) / 100
                        )
                      )
                    : this.$helper.toCurrency(i.cost - (i.discount || 0))
                )
                .join(",")
            : "-";
          res.push(meterSetting);
        }
      }
      return res;
    },
    async onInitAreaaccountingproduct() {
      this.isLoading = true;
      try {
        this.getSettingTaskSmall("area_accounting_product");
        await this.$store.dispatch(
          "accountingProducts/getAccountingProducts",
          this.projectId
        );
        await this.$store.dispatch(
          "areaAccountingProduct/getAreaAccountingProductByMarket",
          this.marketId
        );
        this.areasAccountingTable = this.prepareAreaAccountingProduct();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    prepareAreaAccountingProduct() {
      let areasAccountingTable = {};
      areasAccountingTable.headers = [];
      areasAccountingTable.items = [];
      areasAccountingTable.areaAccountingProductObjects = {};
      areasAccountingTable.headers[0] = {
        isSelected: false,
        text: this.$t('bill.order'),
        value: "area.order",
        width: "80px",
        class: "fix-col",
        cellClass: "fix-col",
        align: "center"
      };
      areasAccountingTable.headers[1] = {
        isSelected: false,
        text: this.$t('market.stall_name_and_number'),
        value: "area.name",
        width: "140px",
        class: "fix-col",
        cellClass: "fix-col",
        align: "center"
      };

      if (this.accountingProducts && this.accountingProducts.length) {
        for (let accountingProduct of this.accountingProducts) {
          if (accountingProduct.type != "facility") {
            areasAccountingTable.headers.push({
              text: accountingProduct.name,
              value: accountingProduct.objectId,
              align: "center",
              width: "150px",
              class: "acc-row",
              cellClass: "acc-row"
            });
          }
        }
      }

      if (this.areaAccountingProducts && this.areaAccountingProducts.length) {
        for (let areaAccountingProduct of this.areaAccountingProducts) {
          let area = areaAccountingProduct.area;
          if (!areasAccountingTable.areaAccountingProductObjects[area.objectId])
            areasAccountingTable.areaAccountingProductObjects[
              area.objectId
            ] = [];
          areasAccountingTable.areaAccountingProductObjects[area.objectId].push(
            areaAccountingProduct
          );
        }
      }

      if (this.areas && this.areas.length) {
        for (let area of this.areas) {
          let obj = {
            isSelected: false,
            area: area
          };
          if (
            areasAccountingTable.areaAccountingProductObjects[area.objectId] &&
            areasAccountingTable.areaAccountingProductObjects[area.objectId]
              .length
          ) {
            for (let areaAccountingProduct of areasAccountingTable
              .areaAccountingProductObjects[area.objectId]) {
              let accountingProduct = areaAccountingProduct.accountingProduct;
              obj[accountingProduct.objectId] = areaAccountingProduct;
            }
          }
          areasAccountingTable.items.push(obj);
        }
      }

      return areasAccountingTable;
    },
    onExportAreaAccounting() {
      try {
        ExportMarketSetting.exportMarketAreaAccountingProduct(
          this.areas,
          this.accountingProducts,
          this.areaAccountingProducts
        );
      } catch (error) {
        this.isError = true;
      }
    },
    async onInitBilling() {
      try {
        this.isLoading = true;
        await this.$store.dispatch(
          "accountingProducts/getAccountingProducts",
          this.projectId
        );
        if (this.billingSettingType == "monthly") {
          this.getSettingTaskSmall("billing_setting");
          const billingSetting = await this.$store.dispatch(
            "billingSetting/getBillingSettingsByAreas",
            {
              areaIds: this.$store.getters["markets/getAreaIds"]
            }
          );
          this.areaBillingSettingItems = this.areaBillingSettingItemsFn();
        } else if (this.billingSettingType == "daily") {
          const billingSetting = await this.$store.dispatch(
            "dailyBillingSetting/getDailyBillingSettingsByAreas",
            {
              areaIds: this.$store.getters["markets/getAreaIds"]
            }
          );
          this.areaBillingSettingItems = this.areaDailyBillingSettingItemsFn();
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        this.isLoading = false;
      }
    },
    areaBillingSettingItemsFn() {
      let areaBillingSettingItems = [];
      let areaObject = {};
      if (this.areas && this.areas.length) {
        for (let area of this.areas) {
          const filterArr = this.billingSettings.filter(
            i => i.area && i.area.objectId === area.objectId
          );
          if (filterArr && filterArr.length) {
            area.billingSettings = filterArr;
          } else {
            area.billingSettings = [];
          }
          area.serviceText = area.billingSettings.length
            ? area.billingSettings.map(i => i.accountingProduct.name).join(",")
            : "-";

          area.unitText = area.billingSettings.length
            ? area.billingSettings.map(i => i.typeString).join(",")
            : "-";
          area.discountText = area.billingSettings.length
            ? area.billingSettings
                .map(
                  i =>
                    `${this.$helper.toCurrency(i.discount)}${
                      i.discountType == 2 ? "%" : ""
                    }`
                )
                .join(",")
            : "-";
          area.costText = area.billingSettings.length
            ? area.billingSettings
                .map(i => this.$helper.toCurrency(i.cost))
                .join(",")
            : "-";
          area.totalText = area.billingSettings.length
            ? area.billingSettings
                .map(i =>
                  i.discountType == 2
                    ? this.$helper.toCurrency(
                        this.$helper.round(
                          i.cost - (i.cost * (i.discount || 0)) / 100
                        )
                      )
                    : this.$helper.toCurrency(i.cost - (i.discount || 0))
                )
                .join(",")
            : "-";
          areaBillingSettingItems.push(area);
        }
      }
      return areaBillingSettingItems;
    },
    areaDailyBillingSettingItemsFn() {
      let areaBillingSettingItems = [];
      let areaObject = {};
      if (this.areas && this.areas.length) {
        for (let area of this.areas) {
          let filterArr;
          if (this.dailyBillingSettings && this.dailyBillingSettings.length)
            filterArr = this.dailyBillingSettings.filter(
              i => i.area && i.area.objectId === area.objectId
            );
          if (filterArr && filterArr.length) {
            area.billingSettings = filterArr;
          } else {
            area.billingSettings = [];
          }
          area.serviceText = area.billingSettings.length
            ? area.billingSettings.map(i => i.accountingProduct.name).join(",")
            : "-";

          area.unitText = area.billingSettings.length
            ? area.billingSettings.map(i => i.typeString).join(",")
            : "-";
          area.discountText = "-";
          area.costText = area.billingSettings.length
            ? area.billingSettings
                .map(i => this.$helper.toCurrency(i.cost))
                .join(",")
            : "-";
          area.totalText = "";
          areaBillingSettingItems.push(area);
        }
      }
      return areaBillingSettingItems;
    },
    async onInitSettingTask(settingTaskType) {
      try {
        this.isLoading = true;
        await this.$store.dispatch("settingTask/getSettingTasks", {
          marketId: this.marketId,
          type: settingTaskType
        });
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
      }
    },
    async getSettingTaskSmall(settingTaskType) {
      try {
        await this.$store.dispatch("settingTask/getSettingTasksByMarketSmall", {
          marketId: this.marketId,
          type: settingTaskType
        });
      } catch (err) {}
    },
    changeBillingSettingType(value) {
      if (value && value != this.billingSettingType) {
        this.billingSettingType = value;
        this.onInitBilling();
      }
    }
  }
};
</script>